import {injectReducer} from '../../store/reducers'
import {isLoggedIn} from 'utils/auth'
import {salesPerformanceDetailsReducer, categoryAnalyticsWithComparisonReducer} from './modules/OverallSummary'
import {productWiseSalesAnalyticsReducer} from '../../routes/ProductWiseSalesAnalytics/modules/ProductWiseSalesAnalytics'
import {loadBrandNamesReducer} from '../../routes/SalesAnalytics/modules/salesAnalytics'
import {loadOpportunitiesReducer} from './../Opportunities/modules/Opportunities'

export default (store) => ({
  path: 'overall-summary',
  onEnter: isLoggedIn(store),
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      /*  Return getComponent   */
      const Summary = require('./containers/OverallSummaryContainer').default
      let homeReducers = require('../Home/modules/home')
      const filterValuesReducer = homeReducers.filterValuesReducer
      const productSalesAnalytics = require('../AllProductSalesAnalytics/modules/allProductSalesAnalytics').reducer

      injectReducer(store, {key: 'filter', reducer: filterValuesReducer})
      injectReducer(store, {key: 'salesPerformanceDetails', reducer: salesPerformanceDetailsReducer})
      injectReducer(store, {key: 'categoryAnalyticsWithComparison', reducer: categoryAnalyticsWithComparisonReducer})
      injectReducer(store, {key: 'productWiseSalesDetails', reducer: productWiseSalesAnalyticsReducer})
      injectReducer(store, {key: 'brands', reducer: loadBrandNamesReducer})
      injectReducer(store, {key: 'opportunities', reducer: loadOpportunitiesReducer})
      injectReducer(store, {key: 'allProductSalesAnalytics', reducer: productSalesAnalytics});
      cb(null, Summary)

      /* Webpack named bundle   */
    }, 'HomeView')
  }
})



// WEBPACK FOOTER //
// ./src/routes/OverallSummary/index.js